import { z } from 'zod';

import PartyStatus from '@/store/modules/envelopes/models/PartyStatus';

const Parties = z.array(z.object({
    id: z.number(),
    envelope_id: z.number(),
    email: z.string(),
    message: z.string(),
    order: z.number(),
    party_envelope_id: z.string(),
    preview_url: z.string(),
    role: z.string(),
    signing_url: z.string().optional(),
    status: PartyStatus,
    template_party_ids: z.array(z.number()).nullable(),
    title: z.string(),
}));

export default Parties;
